var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 78,
    viewBox: "0 0 83 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6425 0.0863037C35.6298 0.0863037 23.7128 4.66161 18.9871 11.0756L40.561 33.5245C43.5643 34.0265 46.6007 34.2838 49.6425 34.2942C67.8056 34.2942 82.5169 26.6402 82.5169 17.1903C82.5169 7.74032 67.8056 0.0863037 49.6425 0.0863037ZM16.4394 17.5323L10.6042 23.6042L20.8774 34.2942H0.330933V42.8462H20.8774L10.6042 53.5362L16.4394 59.6081L36.6571 38.5702L16.4394 17.5323ZM82.5169 25.7422C82.5169 35.1922 67.8056 42.8462 49.6425 42.8462C47.0174 42.8387 44.3956 42.653 41.7937 42.2903L31.6438 52.852C37.4661 54.7598 43.5385 55.7119 49.6425 55.6741C67.8056 55.6741 82.5169 48.0201 82.5169 38.5702V25.7422ZM82.5169 47.1222C82.5169 56.5721 67.8056 64.2261 49.6425 64.2261C41.422 64.3734 33.2797 62.5443 25.8497 58.8811L18.9461 66.0648C23.6717 72.4788 35.6298 77.0541 49.6425 77.0541C67.8056 77.0541 82.5169 69.4001 82.5169 59.9501",
    fill: ""
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/dataIcon.ad9917c7.svg";
export { ForwardRef as ReactComponent };